import { TicketOutlined } from 'components/Shared/Icons';

import styles from './styles.module.css';

type EmptyStateProps = {
  showLoadingMessage: boolean;
};

const LoadingState = ({ showLoadingMessage }: EmptyStateProps) => {
  if (!showLoadingMessage) {
    return null;
  }

  return (
    <div className={styles.container}>
      <TicketOutlined />
      <p className={styles.text}>Ingresso escaneado!</p>
      <p className={styles.text}>Validando... um instante, por favor.</p>
    </div>
  );
};

export default LoadingState;
